import { Card, Grid, HueSlider, Text, Textarea } from '@mantine/core';
import LabeledSlider from '../LabeledSlider';

const AdvancedTextPromptSettings = ({ advancedSettings, setAdvancedSettings, visible, systemPromptVisible }) => {
  if (!visible) {
    return;
  }

  return (
    <Card.Section inheritPadding py="sm">
      <Grid align="center" mb="sm">
        <Grid.Col span={{ base: 12, sm: 2 }}>
          <Text fw={500}>Creativity</Text>
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 10 }} pt="md">
          <LabeledSlider
            min={1}
            max={100}
            step={1}
            value={advancedSettings.temperature}
            onChange={(temp) => setAdvancedSettings({ ...advancedSettings, temperature: temp })}
          />
          <Text size="sm" c="dimmed" mt="xs">
            <strong>Creativity</strong> controls how innovative and unexpected the generated output becomes, ranging
            from conventional styles to more imaginative and unforeseen content.
          </Text>
        </Grid.Col>
      </Grid>
      <Grid align="center" mb="sm">
        <Grid.Col span={{ base: 12, sm: 2 }}>
          <Text fw={500}>Word Variety</Text>
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 10 }}>
          <HueSlider
            value={advancedSettings.top_p}
            onChange={(p) => setAdvancedSettings({ ...advancedSettings, top_p: p })}
          />
          <Text size="sm" c="dimmed" mt="xs">
            <strong>Word Variety</strong> adjusts the range and uniqueness of words in the generated text, from using
            similar terms to incorporating a broader spectrum of diverse vocabulary.
          </Text>
        </Grid.Col>
      </Grid>

      {systemPromptVisible && (
        <Grid align="center" mb="sm">
          <Grid.Col span={{ base: 12, sm: 2 }}>
            <Text fw={500}>System Prompt</Text>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 10 }}>
            <Textarea
              rows={1}
              value={advancedSettings.system_prompt}
              onChange={(e) => setAdvancedSettings({ ...advancedSettings, system_prompt: e.target.value })}
            />
            <Text size="sm" c="dimmed" mt="xs">
              <strong>System Prompt</strong> gives the AI model basic instructions on how to respond. Adjusting this
              allows you to customize how the AI model interacts in the chat.
            </Text>
          </Grid.Col>
        </Grid>
      )}
    </Card.Section>
  );
};

export default AdvancedTextPromptSettings;
